module.exports = __webpack_public_path__ + "img/plan.B-title.c09386e8.png";